"use strict";

const ThemePort = {
  add: function (app) {
    if (app.ports.setTheme) {
      app.ports.setTheme.subscribe((theme) => {
        document.body.setAttribute("theme", theme == "wip" ? "v2" : theme);
        document.body.setAttribute(
          "components-theme",
          theme == "wip" ? "wip" : "",
        );
      });
    }
  },
};

module.exports = ThemePort;
